var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.75,77H19.25a2.758,2.758,0,0,0-2.75,2.75v5.5A2.758,2.758,0,0,0,19.25,88h71.5a2.758,2.758,0,0,0,2.75-2.75v-5.5A2.758,2.758,0,0,0,90.75,77Zm11-55a8.252,8.252,0,0,0-8.25,8.25,8.083,8.083,0,0,0,.756,3.4L81.813,41.112a5.493,5.493,0,0,1-7.6-1.994L60.208,14.609a8.25,8.25,0,1,0-10.416,0L35.784,39.119a5.5,5.5,0,0,1-7.6,1.994L15.761,33.653A8.247,8.247,0,1,0,8.25,38.5a8.424,8.424,0,0,0,1.323-.138L22,71.5H88l12.427-33.138a8.424,8.424,0,0,0,1.323.138,8.25,8.25,0,0,0,0-16.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeCrown);
export default __webpack_public_path__ + "static/media/icon-awesome-crown.2b770065ec124cca50acf9111fd882b7.svg";
export { ForwardRef as ReactComponent };